import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild, Output, EventEmitter } from '@angular/core';
import { VisualizerService } from '../../../services/visualizer.service';
import { Subscription } from 'rxjs/Rx';
import { DoCheck, HostListener } from '@angular/core';
import { VisualizerStateReady } from '../../../models/color.model';
import { trigger, state, style, animate, transition, group, query, stagger } from '@angular/animations';
import { StartupService } from '../../../services/startup.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  animations: [
    trigger('loaderAnimate', [
      transition('* => in', [
        query('.animate-loader', style({ transform: 'translateX(600px)', opacity: 0 }), { optional: true }),
        query('.animate-loader',
          stagger('600ms', [
            animate('600ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(0)', opacity: 1 }))
          ]), { optional: true })
      ])
    ])
  ]
})

export class LoaderComponent implements OnInit, OnDestroy {
  @ViewChild('loader') loaderElemennt: ElementRef;

  visualizerState: VisualizerStateReady;
  visualizerStateSubscription: Subscription;
  animationState: string = 'out';
  @Output() loadVisualizer: EventEmitter<string> = new EventEmitter<string>();

  constructor(private visualizerService: VisualizerService, private renderer: Renderer2, public startupService: StartupService) { }

  animationFinished(e) {
    setTimeout(() => {
      this.visualizerState.AnimationIsDone = true;
      this.visualizerService.setVisualizerState(this.visualizerState);
      this.renderer.setStyle(this.loaderElemennt.nativeElement, 'opacity', '0');

      setTimeout(() => { this.hideLoader(); this.loadVisualizer.emit('in'); }, 300);
    }, 1000);
  }

  ngOnInit() {
    this.animationState = 'in';
    this.getVisualizerState();
  }

  hideLoader() {
    this.renderer.setStyle(this.loaderElemennt.nativeElement, 'display', 'none');
  }

  showLoader() {
    this.renderer.setStyle(this.loaderElemennt.nativeElement, 'display', 'block');
  }

  getVisualizerState() {
    this.visualizerStateSubscription = this.visualizerService.isReady.subscribe(state => {
      this.visualizerState = state;
    });
  }
  ngOnDestroy() {
    this.visualizerStateSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/loader/loader.component.ts